import React from 'react';
import { useTranslation } from 'next-i18next';
import Hero from './Hero';
import StepCard from '@/components/referral/StepCard';
import FaqContent from '@/components/shadowban/FAQContent';
import SectionOffer from '@/components/referral/sectionOffer';
import { useSearchParams } from 'next/navigation';

export default function ShadowbanPageClient({ data }: { data: any }) {
  const { t } = useTranslation();
  const { contentData = {} } = data;

  const inviteCode = useSearchParams().get('inviteCode');

  const {
    contentInfo: {
      hero: hero,
      'hero-2': hero2,
      'section-steps': sectionSteps,
      'section-offer': sectionOffer,
      'section-faq': sectionFaq,
    },
    faqList,
  } = contentData;

  return (
    <div className="min-h-screen bg-[url('/images/referral/bg.webp')] bg-no-repeat bg-top bg-[length:100%_auto] max-md:bg-[length:200%_auto]">
      <style>{`
        .layout .main {
          background-image: none;
        }
      `}</style>
      <Hero data={inviteCode ? hero2 : hero} inviteCode={inviteCode} />
      <StepCard data={sectionSteps} />
      <FaqContent className="max-w-[1000px]" faqList={faqList} faqInfo={sectionFaq} />
      <SectionOffer data={sectionOffer} />
    </div>
  );
}
